import { minBreakpoints, primarySemiBoldFont, theme } from '@noths/polaris-client-ribbons-base';
import { mediaQuery, pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';
var responsiveText = theme.responsiveText,
  spacing = theme.spacing;
export var desktopWrapper = /*#__PURE__*/css(["display:none;", ";"], mediaQuery({
  min: minBreakpoints.L
}, css(["display:block;"])));
export var mobileWrapper = /*#__PURE__*/css(["display:block;margin:0;", ";"], mediaQuery({
  min: minBreakpoints.L
}, css(["display:none;"])));
export var list = /*#__PURE__*/css(["display:flex;justify-content:space-between;column-gap:", "px;padding:", " 0 0;list-style-type:none;border-top:1px solid var(--neutral-black-30);border-bottom:1px solid var(--neutral-black-30);", ";"], spacing.lg, pxToRem(spacing.xxl), mediaQuery({
  min: minBreakpoints.L
}, css(["column-gap:", "px;"], spacing.xl)));
export var title = /*#__PURE__*/css(["", ";", ";"], primarySemiBoldFont, responsiveText.HEADING.XS);